// extracted by mini-css-extract-plugin
module.exports = {"checkbox_burger":"Toggler_checkbox_burger__1ae8P","burger_menu":"Toggler_burger_menu__30L9E","overlay":"Toggler_overlay__1eVes","checked":"Toggler_checked__1lpD2"};